import { Injectable, inject, signal } from '@angular/core';

import { SharedFeaturesApiService } from '@frontend/vanilla/core';

import { UserDocumentsResponse } from './user-documents.models';

/**
 * @stable
 */
@Injectable({ providedIn: 'root' })
export class UserDocumentsService {
    private apiService = inject(SharedFeaturesApiService);

    readonly userDocuments = signal<UserDocumentsResponse | null>(null);

    refresh() {
        this.userDocuments.set(null);
        this.loadUserDocuments();
    }

    private loadUserDocuments() {
        if (!this.userDocuments()) {
            this.apiService.get('userdocuments').subscribe((userDocuments: UserDocumentsResponse) => {
                this.userDocuments.set(userDocuments);
            });
        }
    }
}
